import React, { useState } from "react"

import { joinClasses, changeView, useClasses } from "../globals";
import { recoverPassword } from "../simgate";

import {
  Box,
  Button,
  ButtonGroup,
  Collapse,
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Typography
} from "@material-ui/core"
import { Alert } from "@material-ui/lab"

// Icons
import AutorenewIcon from "@material-ui/icons/Autorenew"
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft"
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff"
import { Facebook, GTranslate, Twitter } from "@material-ui/icons"
import { action, makeAutoObservable, runInAction } from "mobx";
import { observer } from "mobx-react-lite";

class ForgotPasswordStore {

  processing = false;

  email = "";
  emailError = "";

  serverError = "";

  constructor(app, email) {
    this.app = app;
    this.email = email;
    makeAutoObservable(this);
  }

  async sendEmail() {

    let cont = true;
    const { email } = this;

    runInAction(() => {
      this.processing = true;
      this.emailError = "";
      this.serverError = "";

      if (!email) {
        this.emailError = "Email Address is required";
        this.processing = false;
        cont = false;
      }
    });

    if (!cont) {
      return;
    }

    try {
      const [result] = await recoverPassword({ email, returnUrl: window.location.href });

      runInAction(() => {
        this.processing = false;
        if (result.error) {
          console.log(result.message);
          this.serverError = "There was an error sending the password recovery email. Please try again.";
        }
        else {
          changeView("PasswordRecoveryComplete", { email });
        }
      });
    }
    catch (e) {
      console.error(e);
      runInAction(() => {
        this.processing = false;
        this.serverError = "There was an error sending the password recovery email. Please try again.";
      });
    }
  }
}

const EmailField = observer(({ classes, store }) => {
  const {
    processing,
    email,
    emailError
  } = store;

  return <Box className={classes._Margin}>
    <TextField
      fullWidth
      variant="outlined"
      size="small"
      onFocus={action(() => {
        store.serverError = false;
        store.emailError = false;
      })}
      label="Email"
      value={email}
      error={Boolean(emailError)}
      disabled={processing}
      onChange={action(event => store.email = event.target.value)}
      helperText={emailError}
      onKeyPress={(e) => { if (e.charCode === 13) { store.sendEmail() } }}
    />
  </Box>
});


const SendEmailButton = observer(({ classes, store }) => {
  const {
    processing
  } = store;

  return <Box className={classes._Padding}>
    <Button
      fullWidth
      color="primary"
      variant="contained"
      disabled={Boolean(processing)}
      onClick={() => store.sendEmail()}
      startIcon={
        processing ? (
          <AutorenewIcon className={classes.processingIcon} />
        ) : null
      }
    >
      Send password reset email
    </Button>
  </Box>
})

const SendEmailError = observer(({ classes, store }) => {
  const {
    serverError
  } = store;

  console.log(serverError);

  return <Collapse in={Boolean(serverError)}>
    <Box mb={2}>
      <Alert severity="error">
        <Typography>{serverError}</Typography>
      </Alert>
    </Box>
  </Collapse>
})


const ReturnButton = observer(({ classes, store }) => {

  return <Box className={classes._PaddingDouble}>
    <Button
      variant="text"
      fullWidth
      onClick={() => changeView("EmailPasswordLogin", { email: store.email })}
      startIcon={<ChevronLeftIcon />}
    >
      Back to Sign in
    </Button>
  </Box>
})

export const PasswordRecovery = observer(({ email }) => {

  const classes = useClasses()
  const [store] = useState(() => new ForgotPasswordStore(app, email));

  return (
    <React.Fragment>
      <Box
        className={joinClasses(
          classes._Flex,
          classes._FlexDirectionColumn,
          classes._Padding
        )}
      >

        <EmailField classes={classes} store={store} />
        <Box className={classes._Margin}>
          <Collapse in>
            <Alert severity="info">
              Enter your account's email address and
              we will send you a password reset email.
            </Alert>
          </Collapse>
        </Box>
        <SendEmailError classes={classes} store={store} />
        <SendEmailButton classes={classes} store={store} />
      </Box>

      <Divider />
      <ReturnButton classes={classes} store={store} />


    </React.Fragment>
  )
})

PasswordRecovery.title = "Password Recovery";